import {KTSVG} from '../../../helpers'
import {useState} from 'react'
import {useParams} from 'react-router-dom'

function InititateHandshake() {
  let {pointId} = useParams();
  const [data, setData] = useState();

  return (
    <div className='modal fade' tabIndex={-1} id='get_initiate_handshake'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Initiate Handshake</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InititateHandshake
